exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".action-link[data-v-d7efefbc]{cursor:pointer}.m-b-none[data-v-d7efefbc]{margin-bottom:0}", ""]);

// exports
